<template>
  <div
    v-if="richText"
    :class="$style.root"
  >
    <core-text-component :string="richText" />
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
    richText: string
  }>()
</script>

<style module>
.root:not([data-first-block]) {
  margin-top: calc(var(--font-default--line-height) - var(--font-default--font-size));
}

.root:not([data-last-block]) {
  margin-bottom: calc(var(--font-default--line-height) - var(--font-default--font-size));
}

.root {
  composes: font-size-small from global;

  padding: var(--padding--element);

  backdrop-filter: var(--backdrop-filter--dark);
  border-radius: var(--border-radius--default);
}
</style>
